<div class="login-container" *ngIf="!forgotPassword">
    <div class="login-form-wrapper">
        <div class="login-form-container">
            <div class="app-logo">
                <app-svg-icon [iconPath]="'assets/img/new-designs/app_logo.svg'"></app-svg-icon>
            </div>
            <div class="login-form-content">
                <div>
                    <h3 class="login-form-heading">Log In to Wise Pelican</h3>
                    <p class="login-form-text">
                        Don't have an account yet? <a class="login-form-link" [routerLink]="'/signup'" alt="Create Account">Create Account</a>
                    </p>
                </div>
                <form hs-do-not-collect="true" (keydown.enter)="$event.preventDefault(); onLoginButtonClicked()">
                    <div class="login-form-input-group">
                        <app-outlined-input-field
                            #emailLoginElement
                            label="Email Address"
                            startIcon="assets/img/new-designs/icons/email.svg"
                            [control]="loginFormControls.email"
                            placeholder="Enter your email"
                            [errorMessage]="getControlErrorMessage(loginFormControls.email, 'email')"
                        >
                        </app-outlined-input-field>
                        <app-outlined-input-field
                            label="Password"
                            placeholder="Password"
                            type="password"
                            startIcon="assets/img/new-designs/icons/lock-icon.svg"
                            [control]="loginFormControls.password"
                            [errorMessage]="getControlErrorMessage(loginFormControls.password, 'password')"
                        >
                        </app-outlined-input-field>
                    </div>
                    <div class="login-form-forgot-password">
                        <a class="forgot-password-link" (click)="onResetPasswordFooterClick()"> Forgot Password? </a>
                    </div>
                    <app-base-button
                        type="primary"
                        (buttonClick)="onLoginButtonClicked()"
                        [disabled]="isLoginButtonDisabled()"
                        [isLoading]="isLoggingIn"
                        [fullWidth]="true"
                        size="large"
                    >
                        Log In
                    </app-base-button>
                </form>
            </div>
        </div>
    </div>
    <div class="login-product-details">
        <div class="showcase-image">
            <img [src]="'assets/img/new-designs/login-app-showcase.png'" alt="Wise Pelican App Showcase" />
        </div>
        <div>
            <h2 class="login-product-heading-primary">
                Never Miss a Mailing with Our <br />
                <span class="proven-text">
                    Set-it-and-Forget-it
                    <app-svg-icon class="underline-icon" [iconPath]="'assets/img/new-designs/hand-drawn-underlines.svg'"></app-svg-icon>
                </span>
                Subscription Plans
            </h2>

            <h5 class="login-product-subheading">
                Set your mailings and forget about them for a whole year. <br />
                Our subscription manages everything from design to delivery, ensuring you maximize ROI with zero hassle
            </h5>
        </div>
    </div>
</div>

<div *ngIf="forgotPassword" class="forgot-password-container">
    <div class="app-logo">
        <app-svg-icon [iconPath]="'assets/img/new-designs/app_logo.svg'"></app-svg-icon>
    </div>
    <div class="forgot-password-centered-wrapper">
        <div class="forgot-password-content">
            <div class="icon-lock">
                <app-svg-icon [iconPath]="'assets/img/new-designs/icons/forgot-password-lock-purple-gold.svg'"></app-svg-icon>
            </div>
            <h3 class="forgot-password-heading">Forgot Password?</h3>
            <p class="forgot-password-text">Please enter the email address associated with your account, and we'll email you a link to reset your password.</p>
            <form hs-do-not-collect="true" [formGroup]="resetPasswordForm">
                <app-outlined-input-field
                    label="Email Address"
                    startIcon="assets/img/new-designs/icons/email.svg"
                    [control]="resetPasswordFormControl.email"
                    placeholder="Enter your email"
                    [errorMessage]="getControlErrorMessage(resetPasswordFormControl.email, 'email')"
                >
                </app-outlined-input-field>

                <app-base-button
                    buttonType="submit"
                    type="primary"
                    (buttonClick)="onResetPasswordButtonClick()"
                    [disabled]="isLoggingIn || isResettingPassword"
                    [isLoading]="isLoggingIn"
                    [fullWidth]="true"
                    size="large"
                >
                    Reset Password
                </app-base-button>

                <div class="forgot-password-back-btn">
                    <app-base-button
                        class="back-button"
                        startIcon="assets/img/new-designs/icons/chevron-left-purple.svg"
                        type="primary"
                        (buttonClick)="onReturnToLoginFooterClick()"
                        [disabled]="isLoggingIn || isResettingPassword"
                        [isLoading]="isLoggingIn"
                        [fullWidth]="true"
                        size="large"
                        buttonVariant="text"
                    >
                        Return to Log In
                    </app-base-button>
                </div>
            </form>
        </div>
    </div>
</div>
